import { set } from "date-fns";
import { useEffect, useState } from "react"

const useAdmin = user => {

    const [admin, setAdmin] = useState(false);
    const [adminLoading, setAdminLoading] = useState(true);
    useEffect(() => {
        const email = user?.email;

        if (email) {
            fetch(`http://localhost:5000/admin/${email}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('access-token')}`
                }
            })
                .then(res => res.json())
                .then(data => {
                    console.log('data inside admin', data);
                    setAdmin(data.admin)
                    setAdminLoading(false);
                })
        }
    }, [user])
    return [admin, adminLoading];
}
export default useAdmin;
